import React from "react";
import { connect } from "unistore/react";
import { actions } from "./store";
import { List } from "./list";

class Filters extends React.Component {
  addActiveClassName(buttonType) {
    return this.props.filter === buttonType ? "active" : "inactive";
  }

  render() {
    return (
      <div className="filters">
        <div className="filterButtons">
          <button
            onClick={_ => this.props.setFilter("all")}
            className={`filterButton ${this.addActiveClassName("all")}`}
          >
            All
          </button>
          <button
            onClick={_ => this.props.setFilter("red")}
            className={`filterButton ${this.addActiveClassName("red")}`}
          >
            Red
          </button>
          <button
            onClick={_ => this.props.setFilter("blue")}
            className={`filterButton ${this.addActiveClassName("blue")}`}
          >
            Blue
          </button>
        </div>
        <List />
      </div>
    );
  }
}

const connectedFilters = connect(
  "filter",
  actions
)(Filters);

export { connectedFilters as Filters };
